import { Skeleton, Typography,  Fade } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";

const IntroText = ({ content, loading }) => {

    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const element = document.getElementById("intro-text");
            if (element) {
                const rect = element.getBoundingClientRect();
                const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
                setIsVisible(isVisible);
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
        }
    }, []);


    return (
        <Box
            id="intro-text"
            sx={{
                maxWidth: "1200px",
                margin: "60px auto 70px auto",
                padding: "0 4%",
            }}
        >
            {loading ?
                <>
                    <Skeleton 
                        variant="text" 
                        width="100%" 
                        height="100px" 
                        sx={{
                            maxWidth: "1200px",
                            margin: "60px auto 0px auto",
                            padding: "0 4%",
                        }}
                    />
                    <Skeleton 
                        variant="text" 
                        width="100%" 
                        height="88px" 
                        sx={{
                            maxWidth: "1200px",
                            padding: "0 4%",
                        }}
                    />
                    <Skeleton 
                        variant="text" 
                        width="100%" 
                        height="22px" 
                        sx={{
                            maxWidth: "25px",
                            padding: "0 4%",
                            margin: "0 auto",
                        }}
                    />
                </>
            : content ?
                <>
                    <Fade in={isVisible} timeout={1000}>
                        <h1
                            style={{
                                textAlign: "center",
                                color: "#0C5EAA",
                                fontWeight: "600",
                                lineHeight: "1.5em",
                            }}
                        >
                            {content.intro_title}
                        </h1>
                    </Fade>
                    <Fade in={isVisible} timeout={2000}>
                        <Box
                            dangerouslySetInnerHTML={{ __html: content.intro_content }}
                        />
                    </Fade>
                </>
            : null}
        </Box>
    );
};


export default IntroText;